import React from 'react';
import { Flex, Select, Typography } from 'antd';
import { TimeMs } from '../../types';
import { formatTimecode, TIMECODE_FORMAT_LABELS, TimecodeFormat } from '../../utils/format-time';
import { colors, dimensions, typography } from '../../../theme';
import { usePlayheadValue } from '../../hooks/use-playhead-value';
import { useTimecodeFormat } from '../../hooks/use-timecode-format';
import { usePieceSelector } from '../../../model/piece-context';

const { Text } = Typography;

type TimeDisplayProps = {
  total: TimeMs;
};

const FORMAT_OPTIONS = (Object.entries(TIMECODE_FORMAT_LABELS) as [TimecodeFormat, string][]).map(([value, label]) => ({
  value,
  label
}));

export const TimeDisplay: React.FC<TimeDisplayProps> = ({ total }) => {
  const current = usePlayheadValue();
  const fps = usePieceSelector(m => m.fps);
  const [format, setFormat] = useTimecodeFormat();

  return (
    <Flex
      align='center'
      gap={dimensions.spacing.md}
      style={{
        padding: `${dimensions.spacing.sm}px ${dimensions.spacing.md}px ${dimensions.spacing.sm}px ${dimensions.spacing.xl}px`,
        borderRadius: dimensions.radius.pill,
        backgroundColor: colors.surfaceElevated,
        fontSize: typography.fontSize.md,
        fontWeight: typography.fontWeight.medium,
        whiteSpace: 'nowrap'
      }}
    >
      <Text style={{ color: colors.textPrimary, fontVariantNumeric: 'tabular-nums' }}>
        {formatTimecode(current, format, fps)}
      </Text>
      <Text style={{ color: colors.textMuted, fontVariantNumeric: 'tabular-nums' }}>
        / {formatTimecode(total, format, fps)}
      </Text>
      <Select
        size='small'
        value={format}
        onChange={setFormat}
        options={FORMAT_OPTIONS}
        variant='borderless'
        popupMatchSelectWidth={120}
        style={{ width: 92, fontSize: typography.fontSize.sm }}
      />
    </Flex>
  );
};
